var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeIconVer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 28,
    rx: 14,
    fill: "#424850"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4743_82573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6273 16.0801C49.4773 15.9557 49.266 15.937 49.0966 16.0332C48.9314 16.127 48.7592 16.2111 48.5847 16.2833C48.0277 16.5141 47.4424 16.6311 46.8451 16.6311C44.997 16.6311 43.3459 15.5279 42.6387 13.8205C42.1735 12.6974 42.1735 11.4605 42.6387 10.3374C43.1039 9.21441 43.9786 8.33972 45.1015 7.87456C45.2767 7.80206 45.458 7.73981 45.6404 7.68956C45.8282 7.63781 45.9645 7.47522 45.9825 7.28119C46.0006 7.08716 45.8968 6.90219 45.7218 6.81659C44.6294 6.28234 43.4122 6 42.2017 6C41.1515 6 40.123 6.20541 39.1449 6.61053C37.1711 7.42813 35.6339 8.96537 34.8163 10.9391C33.9987 12.9129 33.9987 15.0869 34.8163 17.0606C35.4336 18.5508 36.4704 19.8043 37.8145 20.6855C39.1261 21.5455 40.6456 22 42.2086 22C43.2591 22 44.2879 21.7945 45.2664 21.3892C47.3844 20.5119 49.0264 18.7638 49.7714 16.593C49.8346 16.4087 49.7772 16.2045 49.6273 16.0801ZM44.9075 20.523C44.0434 20.881 43.1354 21.0625 42.2086 21.0625C39.3414 21.0625 36.7797 19.3508 35.6824 16.7018C34.9607 14.9594 34.9607 13.0403 35.6824 11.2979C36.4041 9.55547 37.7612 8.19844 39.5036 7.47669C40.3675 7.11891 41.2753 6.9375 42.2017 6.9375C42.8918 6.9375 43.5845 7.04153 44.2485 7.24231C41.7939 8.55678 40.685 11.5537 41.7726 14.1792C42.1962 15.2019 42.9076 16.0621 43.83 16.6668C44.7299 17.2568 45.7725 17.5686 46.8451 17.5686C47.3841 17.5686 47.9148 17.4898 48.4287 17.3338C47.6633 18.7618 46.4235 19.8951 44.9075 20.523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4743_82573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(34 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIconVer2);
export default __webpack_public_path__ + "static/media/dark-mode-icon-ver-2.03c5454715838ecccd562131cd741c7d.svg";
export { ForwardRef as ReactComponent };